// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20SKJ","colBig":"styles_colBig__1EsyJ","colSmall":"styles_colSmall__2Y8Ua"};